import { useSelector } from 'react-redux';

export function useProductsFeedPermissions() {
  const currentUser = useSelector((state) => state.role.user);
  const supplier = useSelector((state) => state.role.supplier);
  const isCymbioUser = ['support', 'admin'].includes(currentUser?.role);
  const isEnabledBySupplierConfig =
    supplier?.products_integration_config?.app_configuration?.enable_product_feeds ?? false;

  const isProductsFeedEnabled = isCymbioUser || isEnabledBySupplierConfig;
  return { isProductsFeedEnabled };
}
